import React, { useContext as useContextCore } from 'react'
import type { UseListResult } from '@ztechapps/common.hook'
import { useMailgunEventList } from '@ztechapps/common.hook'
import type { MailgunEvent } from '@ztechapps/common.contract'

export type MailgunEventProviderProps = {
  children: React.ReactNode
  mailgunEventFilterCategory: string
}

export type MailgunEventContextType = { mailgunEventListResult: UseListResult<MailgunEvent>; filterCategory: string } & Omit<
  MailgunEventProviderProps,
  'children'
>

const context = React.createContext<MailgunEventContextType>({} as MailgunEventContextType)
const CoreProvider = context.Provider

export const MailgunEventProvider = ({ children, mailgunEventFilterCategory, ...props }: MailgunEventProviderProps) => {
  const filterCategory = mailgunEventFilterCategory
  const mailgunEventListResult = useMailgunEventList({ listActionOptions: { storageKey: filterCategory } })
  return <CoreProvider value={{ mailgunEventListResult, filterCategory, mailgunEventFilterCategory, ...props }}>{children}</CoreProvider>
}

export const useMailgunEventContext = () => useContextCore(context)
